import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "header"
  }, [_c("el-form", {
    ref: "form",
    staticClass: "demo-form-inline",
    attrs: {
      inline: true,
      rules: _vm.rules,
      model: _vm.model,
      size: "small"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "作业编码"
    }
  }, [_c("el-input", {
    attrs: {
      clearable: "",
      disabled: _vm.loading,
      placeholder: "作业编码"
    },
    model: {
      value: _vm.model.c01TaskCode,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "c01TaskCode", $$v);
      },
      expression: "model.c01TaskCode"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "客户名"
    }
  }, [_c("el-input", {
    attrs: {
      clearable: "",
      disabled: _vm.loading,
      placeholder: "客户名"
    },
    model: {
      value: _vm.model.c01CusName,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "c01CusName", $$v);
      },
      expression: "model.c01CusName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "架构"
    }
  }, [_c("cpsc-select", {
    attrs: {
      clearable: "",
      filterable: "",
      disabled: _vm.loading,
      placeholder: "架构"
    },
    model: {
      value: _vm.model.c01StrucCode,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "c01StrucCode", $$v);
      },
      expression: "model.c01StrucCode"
    }
  }, _vm._l(_vm.strucList, function (item) {
    return _c("el-option", {
      key: item.l01Id,
      attrs: {
        label: "".concat(item.l01StrucCode, "(").concat(item.l01Name, ")"),
        value: item.l01StrucCode
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "负责人"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.loading,
      placeholder: "负责人"
    },
    model: {
      value: _vm.model.fic,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "fic", $$v);
      },
      expression: "model.fic"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "份数",
      prop: "unclaimedCount"
    }
  }, [_c("el-input", {
    staticClass: "input-with-select",
    attrs: {
      placeholder: "",
      disabled: _vm.loading
    },
    model: {
      value: _vm.model.unclaimedCount,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "unclaimedCount", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "model.unclaimedCount"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "80px"
    },
    attrs: {
      slot: "prepend",
      placeholder: "请选择"
    },
    slot: "prepend",
    model: {
      value: _vm.model.type,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "type", $$v);
      },
      expression: "model.type"
    }
  }, [_c("el-option", {
    attrs: {
      label: "大于",
      value: ">"
    }
  }), _c("el-option", {
    attrs: {
      label: "等于",
      value: "="
    }
  }), _c("el-option", {
    attrs: {
      label: "小于",
      value: "<"
    }
  })], 1)], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v("查询")]), _c("el-button", {
    attrs: {
      type: "success",
      disabled: _vm.tableData.length === 0,
      loading: _vm.loading
    },
    on: {
      click: _vm.export2Excel
    }
  }, [_vm._v("导出excel")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      "summary-method": _vm.getSummaries,
      "show-summary": "",
      size: "small"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "c01TaskCode",
      label: "作业编码",
      width: "80"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "c01CusName",
      label: "客户名",
      width: "180"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "_structCode",
      width: "120",
      label: "架构"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "fic",
      width: "85",
      label: "现场负责人"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "unclaimedCount",
      width: "100",
      sortable: "",
      label: "未领取数"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };